import React, { Fragment } from "react";
import { Day, ToDateJalali } from "../../../../Common/Function/index";

function Details({ data }) {
  return (
    <div>
      {data.map((element, key) => {
        return (
          <Fragment key={key}>
            <div className="d-flex justify-content-between form-control mt-2">
              <span>نام کلاس</span>
              <span>{element.name}</span>
            </div>

            <div className="d-flex justify-content-between form-control mt-2">
              <span>تاریخ شروع</span>
              <span>{ToDateJalali(element.exp_register)}</span>
            </div>

            <div className="d-flex justify-content-between form-control mt-2">
              <span>نحوه برگزاری</span>
              <span>{element.type}</span>
            </div>
            <div className="d-flex justify-content-between form-control mt-2">
              <span>قیمت</span>
              <span>{element.price.price}</span>
            </div>
            <div className="d-flex justify-content-between form-control mt-2">
              <span>مهلت ثبت نام</span>
              <span>{element.exp_register}</span>
            </div>
            {element.details_session && element.details_session.length > 0 && (
              <div>
                <h4>روزهای کلاس:</h4>
                {element.details_session.map((date, key) => {
                  return (
                    <Fragment key={key}>
                      <div className="d-flex justify-content-between form-control mt-2">
                        <span>{Day(date.day)}</span>
                        <div>
                          <span>{date.start}</span>
                          <span>{` تا `}</span>
                          <span>{date.end}</span>
                        </div>
                      </div>
                    </Fragment>
                  );
                })}
              </div>
            )}

            <div className="mt-2">
              <h6> مدرسین</h6>
              {element &&
                element.teachers &&
                element.teachers.map((teacher, key) => {
                  return (
                    <Fragment key={key}>
                      <div>
                        <div className="d-flex justify-content-between form-control mt-2">
                          <span>نام مدرس:</span>
                          <span>{teacher.name}</span>
                        </div>
                        <div className="d-flex justify-content-between form-control mt-2">
                          <span>سابقه</span>
                          <span>{teacher.activity}</span>
                        </div>
                        <div className="d-flex justify-content-between form-control mt-2">
                          <span>مدارک</span>
                          <span>{teacher.proof}</span>
                        </div>
                        <div className="d-flex justify-content-between form-control mt-2">
                          <span>افتخارات</span>
                          <span>{teacher.cv}</span>
                        </div>
                      </div>
                    </Fragment>
                  );
                })}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}

export default Details;
